import { axios } from 'utils/networkRequests';

export const reviews = {
  create: (review: any) => axios.post('/v3/facility/reviews', { review }),
  update: (review: any, reviewId: number) =>
    axios.put(`/v3/facility/reviews/${reviewId}`, { review }),
};
